module.exports = __webpack_public_path__ + "static/media/zoleLose_25000_50000.a72ee67f.png";